import { FieldValidator } from 'final-form'
import _ from 'lodash'
import moment, { Moment } from 'moment'
import { Validation } from '@briq/shared'

import { UploadInputButtonValue } from '../components/UploadInputButton'

export type LocalizedMessage = Validation.LocalizedMessage

export const createFormValidator = Validation.createFormValidator

export const composeValidators = Validation.composeValidators

export type FieldInterceptor<T> = Validation.FieldInterceptor<T>
export const composeInterceptors = Validation.composeInterceptors

export const maxLengthInterceptor = Validation.maxLengthInterceptor

export function error(translationKey: string, interpolation?: any, defaultMessage?: string): LocalizedMessage {
  return Validation.error(translationKey, interpolation, defaultMessage)
}

export const required = Validation.required

export const requiredFile = (): FieldValidator<UploadInputButtonValue> => value =>
  _.size(value?.fileList) === 0 ? error('Required') : undefined

export const requiredIf = Validation.requiredIf

export const requiredTrue = Validation.requiredTrue

export const requiredTrueIf = Validation.requiredTrueIf

export const isTrue = Validation.isTrue

export const minLength = Validation.minLength

export const maxLength = Validation.maxLength

export const length = Validation.length

export const emptyOrLength = Validation.emptyOrLength

export const mustMatch = Validation.mustMatch

export const strongPassword = Validation.strongPassword

export const notOldPassword = Validation.notOldPassword

export const email = Validation.email

export const dateCannotBeMoreThanOther =
  <T extends object>(
    compareToField: string,
    err?: string,
    condition?: (allValues: T, meta: any) => boolean
  ): FieldValidator<Moment | undefined> =>
  (inValue, values, meta) => {
    // clone date otherwise date is mutated by endOf
    const value = inValue?.clone()
    // @ts-ignore
    if (condition && !condition(values, meta)) {
      return undefined
    }

    const empty = required()(value, values, meta)
    if (empty) return empty

    // @ts-ignore
    const otherDate: Moment | undefined = values[compareToField]?.clone()

    if (!value || !otherDate || !moment.isMoment(otherDate)) return undefined
    if (value.endOf('D').diff(otherDate.endOf('D')) > 0) return error(err || 'DateMore')
    return undefined
  }

export const dateCannotBeLessThanOther =
  <T extends object>(
    compareToField: string,
    err?: string,
    condition?: (allValues: T, meta: any) => boolean
  ): FieldValidator<Moment | undefined> =>
  (inValue, values, meta) => {
    // clone date otherwise date is mutated by endOf
    const value = inValue?.clone()
    // @ts-ignore
    if (condition && !condition(values, meta)) return undefined

    const empty = required()(value, values, meta)
    if (empty) return empty

    // @ts-ignore
    const otherDate: Moment | undefined = values[compareToField]?.clone()

    if (!value || !otherDate || !moment.isMoment(otherDate)) return undefined
    if (value.endOf('D').diff(otherDate.endOf('D')) < 0) return error(err || 'DateIsLess')
    return undefined
  }

export const phoneNumber = Validation.phoneNumber

export const onlyNumeric = Validation.onlyNumeric
